import React from 'react';
import { Route, Routes } from 'react-router-dom';
import BindRouter from './mobile/BindRouter';
import CarRouter from './mobile/CarRouter';

import RecommendProject from 'pages/mobile/others/RecommendProject';
import CommonQuestion from 'pages/mobile/others/CommonQuestion';
import PreferenceQuestionnaire from 'pages/mobile/others/PreferenceQuestionnaire';
import Chat from 'pages/mobile/others/Chat';
import ChatRoom from 'pages/mobile/others/ChatRoom';
import ChatList from 'pages/mobile/others/ChatList';
import PreferenceQuestionnaireSuccess from 'pages/mobile/others/PreferenceQuestionnaireSuccess';
import BusinessCard from 'pages/mobile/others/BusinessCard';

const MobileRouter = () => {
  return (
    <Routes>
      <Route path="/Bind/*" element={<BindRouter />}></Route>
      <Route path="/Car/*" element={<CarRouter />}></Route>
      <Route path="/RecommendProject" element={<RecommendProject />}></Route>
      <Route path="/CommonQuestion" element={<CommonQuestion />}></Route>
      <Route
        path="/PreferenceQuestionnaireSuccess"
        element={<PreferenceQuestionnaireSuccess />}></Route>
      <Route path="/Chat" element={<Chat />}></Route>
      <Route
        path="/PreferenceQuestionnaire"
        element={<PreferenceQuestionnaire />}></Route>
      <Route path="/BusinessCard" element={<BusinessCard />}></Route>
    </Routes>
  );
};

export default MobileRouter;
